import {
  SearchStatusMasterRequest,
  DetailStatusMasterRequest,
  UpdateStatusMasterRequest,
  DeleteStatusMasterRequest,
} from 'api-types/src/types/status-master'
import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { addStatusAPI, deleteStatusAPI, getStatusAPI, getStatusDetailAPI, updateStatusAPI } from './api';
import {
  filterStatus,
  filterStatusSuccess,
  filterStatusFailure,
  getDetailStatus,
  getDetailStatusSuccess,
  getDetailStatusFailure,
  registerStatusSuccess,
  registerStatusFailure,
  registerStatus,
  updateStatusSuccess,
  updateStatusFailure,
  deleteStatusSuccess,
  deleteStatusFailure,
  updateStatus,
  deleteStatus,
} from './slice';

function* fetchStatusMaster({ payload }: { payload: SearchStatusMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getStatusAPI, trimQueryData(payload));
    yield put(filterStatusSuccess(response.data));
  } catch (error) {
    yield put(filterStatusFailure());
  }
}

function* fetchStatusDetail({ payload }: { payload: DetailStatusMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(getStatusDetailAPI, payload);
    yield put(getDetailStatusSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailStatusFailure({ message: error?.message }));
  }
}

function* registerStatusSaga({ payload }: { payload: UpdateStatusMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(addStatusAPI, payload);
    yield put(registerStatusSuccess(response));
  } catch (error: any) {
    yield put(registerStatusFailure({ message: error?.message }));
  }
}

function* updateStatusSaga({ payload }: { payload: UpdateStatusMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateStatusAPI, payload);
    yield put(updateStatusSuccess(response));
  } catch (error: any) {
    yield put(updateStatusFailure({ message: error?.message }));
  }
}

function* deleteStatusSaga({ payload }: { payload: DeleteStatusMasterRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteStatusAPI, payload);
    yield put(deleteStatusSuccess(response));
  } catch (error: any) {
    yield put(deleteStatusFailure({ message: error?.message }));
  }
}

function* watchStatusMaster() {
  yield takeLatest(filterStatus, fetchStatusMaster);
  yield takeLatest(getDetailStatus, fetchStatusDetail);
  yield takeLatest(registerStatus, registerStatusSaga);
  yield takeLatest(updateStatus, updateStatusSaga);
  yield takeLatest(deleteStatus, deleteStatusSaga);
}

export default watchStatusMaster;
